import { gql } from '@apollo/client/core';

const NotificationPostPreviewFragment = gql`
  fragment PostPreview on Post {
    slug
    archivedAt
    author {
      __typename
      ... on Anonymous {
        username
        warRoomAvatarUrl
      }

      ... on Public {
        slug
        firstname
        lastname
        avatarUrl
      }
    }
    content {
      ... on Link {
        id
        title
      }
      ... on LinkedinPost {
        id
        title
      }
      ... on Story {
        id
        title
        rawText
      }
      ... on YoutubeLink {
        id
        title
      }
    }
  }
`;

export default NotificationPostPreviewFragment;
